import React from "react";
import DashboardWrapper from "components/lib/Global/DashboardWrapper";
import Hero from "components/lib/Global/Hero";
import SuperComplianceDashboard from "components/Compliance/SuperComplianceDashboard";
import ComplianceAccessGate from "components/Compliance/ComplianceAccessGate";

const SuperComplianceDashboardPage = () => (
  <DashboardWrapper>
    <ComplianceAccessGate allowAdminBypass>
      <div className="space-y-8 py-10">
        <Hero
          heading="SuperAdmin Compliance Summary"
          description="Portfolio-level compliance telemetry across all organizations."
        />
        <SuperComplianceDashboard />
      </div>
    </ComplianceAccessGate>
  </DashboardWrapper>
);

export default SuperComplianceDashboardPage;
